import React from "react";
import { Button, Col, Row } from "reactstrap";

import { toast } from "react-toastify";
import FormField from "./FormField";

const LocationPicker = ({ errors, control, setValue, fields, watch }) => {
  // ** location handler function
  const locationPicker = () => {
    const geolocation = window.navigator.geolocation;
    if (geolocation) {
      window.navigator.geolocation.getCurrentPosition((position) => {
        setValue("lat", position.coords.latitude);
        setValue("long", position.coords.longitude);
      });
    } else {
      toast.error("Geolocation is not supported by this browser.");
    }
  };
  return (
    <Col md={6}>
      <Row>
        {fields?.map((item, index) => (
          <Col
            {...{
              [item?.device ?? "md"]: item?.deviceSize ?? (index === 0 ? 5 : 7),
            }}
            key={index}
          >
            <div className="form__form-group">
              <label className="form__form-group-label">{item?.label}</label>
              <div className="form__form-group-field">
                <FormField
                  errors={errors}
                  control={control}
                  name={item?.name}
                  component="input"
                  onChange={(e) => {
                    setValue(item?.name, Number(e.target.value));
                  }}
                  type="number"
                  step={"any"}
                  rules={item?.rules({ watch })}
                  placeholder={item?.placeholder}
                  defaultValue={item?.defaultValue}
                />

                {index === 1 && (
                  <Button
                    onClick={(e) => locationPicker(e)}
                    className="btn-sm ml-3"
                    type="button"
                  >
                    <span className="lnr lnr-map-marker"></span>
                  </Button>
                )}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default LocationPicker;
